/** Customer-facing copy for direct PayPal checkout from BookAPT. */
export const CUSTOMER_PAYPAL_PAYMENT_HELP =
  'You pay the business directly on PayPal (PayPal balance or debit/credit card). BookAPT does not process or hold your payment. The business confirms payment in BookAPT after they receive it.';

/** Seller setup guidance in Payment Providers. */
export const SELLER_PAYPAL_SETUP_HELP =
  'Add your PayPal.me username so customers can pay you directly. BookAPT never holds funds — you confirm in the app when PayPal shows the payment.';

export const SELLER_PAYPAL_CONFIRM_HELP =
  'When a customer pays on PayPal, mark the appointment paid in BookAPT after you see the payment in your PayPal account.';
